import { Fragment } from 'react';
import PropTypes from 'prop-types';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';


function Arrows(props) {
  const {
    hasExtraSlide,
    isInfinite,
    activeIndex,
    totalCount,
    isFullscreen,
    prevHandler,
    nextHandler,
    arrowsShift,
    theme,
  } = props;

  const arrowsAtoms = theme.controls.gallery.arrows;
  const idleAtoms = arrowsAtoms[isFullscreen ? 'idleFullscreen' : 'idle'];
  const hoverAtoms = arrowsAtoms[isFullscreen ? 'hoverFullscreen' : 'hover'];
  const {
    Left,
    Right,
  } = arrowsAtoms;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
      .${styles.zone}
        transition opacity ${theme.animations.hover}
        :global([id*="$"])
        :global([id*="!"])
          transition stroke, fill ${theme.animations.hover}

        :global([id*="$"])
          fill ${idleAtoms.fill}
        :global([id*="!"])
          stroke ${idleAtoms.stroke}

        &:hover
          :global([id*="$"])
            fill ${hoverAtoms.fill}
          :global([id*="!"])
            stroke ${hoverAtoms.stroke}
        &.${styles.leftArrow}
          &:not(&.${styles.fullscreen})
            left ${arrowsShift}px
        &.${styles.rightArrow}
          &:not(&.${styles.fullscreen})
            right ${arrowsShift}px
    `}</style>
    </scope>
  );

  const hidePrevArrow = !isInfinite && !activeIndex;
  const hideNextArrow = !isInfinite && activeIndex + 1 >= totalCount + hasExtraSlide;

  return (
    <Fragment>
      <div
        onClick={hidePrevArrow ? null : prevHandler}
        className={scope.wrapClassNames(
          'zone', // используется как глобальный селектор CSS
          styles.zone,
          styles.leftArrow,
          hidePrevArrow && styles.disabledZone,
          isFullscreen && styles.fullscreen
        )}
      >
        <Left />
      </div>
      <div
        onClick={hideNextArrow ? null : nextHandler}
        className={scope.wrapClassNames(
          'zone', // используется как глобальный селектор CSS
          styles.zone,
          styles.rightArrow,
          hideNextArrow && styles.disabledZone,
          isFullscreen && styles.fullscreen
        )}
      >
        <Right />
      </div>
      <scope.styles />
    </Fragment>
  );
}

const arrowsStateContract = `{
  fill,
  stroke,
}`;

Arrows.defaultProps = {
  arrowsShift: 0,
};

Arrows.propTypes = {
  hasExtraSlide: PropTypes.bool,
  isInfinite: PropTypes.bool,
  activeIndex: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  isFullscreen: PropTypes.bool,
  prevHandler: PropTypes.func.isRequired,
  nextHandler: PropTypes.func.isRequired,
  slideWidth: PropTypes.number,
  arrowsShift: PropTypes.number,
  theme: themePropTypes(`
    {
      animations: {
        hover,
      },

      controls: {
        gallery: {
          arrows: {
            Left,
            Right,
            idle: ${arrowsStateContract},
            idleFullscreen: ${arrowsStateContract},
            hover: ${arrowsStateContract},
            hoverFullscreen: ${arrowsStateContract}
          },
        },
      },
    }
  `),
};

export default withTheme(Arrows);
